export default function ({ next, store, nextMiddleware }) {
  if (!store.getters.isDeveloper) {
    return next({ name: "homepage" });
  }

  return nextMiddleware();
}
